<div class="select-container" [ngClass]="{'error': error}">
  @if (label) {
    <label [for]="selectId" class="select-label">{{ label }}</label>
  }

  <p-select
    #selectRef
    [options]="options"
    [(ngModel)]="selectedOption"
    [placeholder]="placeholder ?? ('common.placeholders.select' | transloco)"
    [disabled]="disabled"
    [loading]="loading"
    [ngClass]="[size, isDropdownOpen ? 'menu-open' : '']"
    class="custom-select"
    (onShow)="onDropdownOpen()"
    (onHide)="onDropdownClose()"
    (onBlur)="onBlur()"
    [id]="selectId"
    optionLabel="label"
    optionValue="value"
    [filter]="filter"
    [filterPlaceholder]="filterPlaceholder ?? ('common.placeholders.search' | transloco)"
    filterBy="label"
    [appendTo]="appendTo"
  >
    <ng-template pTemplate="selectedItem" let-option>
      @if (showIcon && option?.icon) {
        <div class="flex align-items-center gap-2">
          <img [src]="option.icon" class="flag-icon" />
          <span>{{ option.label }}</span>
        </div>
      } @else {
        <span>{{ option?.label }}</span>
      }
    </ng-template>
    <ng-template pTemplate="item" let-option>
      @if (showIcon && option?.icon) {
        <div class="flex align-items-center gap-2">
          <img [src]="option.icon" class="flag-icon" />
          <span>{{ option.label }}</span>
        </div>
      } @else {
        <span>{{ option?.label }}</span>
      }
    </ng-template>
    <ng-template pTemplate="dropdownicon">
      <lucide-icon [name]="isDropdownOpen ? 'ChevronUp' : 'ChevronDown'" class="custom-icon"></lucide-icon>
    </ng-template>
  </p-select>

  @if (error) {
    <div class="error-message">{{ errorMessage || ('validation.required' | transloco) }}</div>
  }
</div>